// Simple constants for dropdown options
export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'Hindi' },
  { value: 'ta', label: 'Tamil' },
  { value: 'te', label: 'Telugu' },
  { value: 'kn', label: 'Kannada' },
  { value: 'ml', label: 'Malayalam' },
];

export const CARD_TYPE_OPTIONS = [
  { value: 'Business', label: 'Business Card' },
  { value: 'Personal', label: 'Personal Card' },
];

export const INDUSTRY_OPTIONS = [
  { value: '', label: 'Select Industry' },
  { value: 'Technology', label: 'Technology & IT' },
  { value: 'Healthcare', label: 'Healthcare & Medical' },
  { value: 'Finance', label: 'Finance & Banking' },
  { value: 'Education', label: 'Education & Training' },
  { value: 'Retail', label: 'Retail & E-commerce' },
  { value: 'Manufacturing', label: 'Manufacturing & Industrial' },
  { value: 'Professional Services', label: 'Professional Services' },
  { value: 'Real Estate', label: 'Real Estate' },
  { value: 'Food & Beverage', label: 'Food & Beverage' },
  { value: 'Entertainment', label: 'Entertainment & Media' },
  { value: 'Transportation', label: 'Transportation & Logistics' },
  { value: 'Construction', label: 'Construction & Engineering' },
  { value: 'Agriculture', label: 'Agriculture & Farming' },
  { value: 'Legal', label: 'Legal Services' },
  { value: 'Marketing', label: 'Marketing & Advertising' },
  { value: 'Consulting', label: 'Consulting' },
  { value: 'Non-Profit', label: 'Non-Profit & NGO' },
  { value: 'Government', label: 'Government & Public Sector' },
  { value: 'Other', label: 'Other' },
];
